import {User} from './user';
import {Model} from './model';

export class Message implements Model {
  id: number;
  body: string;
  type: string;
  images: Array<any> = [];
  created_at: Object;
  updated_at: Object;
  user: User;

  // Used when storing a message, not actually used when retrieving
  entities: Array<any>;

  constructor(data?) {
    if (data != null) {
      this.fill(data);
    }
  }

  public fill(data) {
    this.id         = data['id'];
    this.body       = data['body'];
    this.type       = data['type'];
    this.images     = data['images'];
    this.user       = data['user'];
    this.created_at = data['created_at'];
    this.updated_at = data['updated_at'];
  }

  public serialize() {
    return this;
  }

}
